import React from 'react';
import { useDispatch } from 'react-redux';
import { RouteProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack/src/types';

import { StyleSheet, View } from 'react-native';
import Landing from '../components/landing/Landing';
import { AuthStackParamList } from '../routes';

export type LandingPageProps = {
  navigation: StackNavigationProp<AuthStackParamList, 'Landing'>;
  route: RouteProp<AuthStackParamList, 'Landing'>;
};

// The landing page will either display an autologin loading box or the login/signup forms
const LandingPage = (props: LandingPageProps) => {
  const handleLogout = async () => {
    location.reload();
  };

  return (
    <View style={styles.root}>
      <Landing onLogout={handleLogout} navigation={props.navigation} route={props.route} />
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#efeeed'
  }
});

export default LandingPage;
